import { render } from "./Payment.vue?vue&type=template&id=5e209c69&ts=true"
import script from "./Payment.vue?vue&type=script&lang=ts"
export * from "./Payment.vue?vue&type=script&lang=ts"

import "./Payment.vue?vue&type=style&index=0&id=5e209c69&lang=scss"

import exportComponent from "/home/newbaidev/public_html/projects-sit/uae/sit-ae-car.new.baidev.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__